'use client'
import { InjectedWalletBase } from './InjectedWalletBase.js';

class FallbackEvmConnector extends InjectedWalletBase {
    constructor() {
        super(...arguments);
        this.name = 'Fallback Connector';
        this.overrideKey = 'fallbackconnector';
        this.isAvailable = false;
    }
    isInstalledOnBrowser() {
        return false;
    }
}

export { FallbackEvmConnector };
